import { Settings } from './Settings';
//import { Math } from './Math'
import { RoundValueASTM } from './FuelMath';
export class IgnitionService {
    static response = {
        CCAITextBox: "",
        CIITextBox: ""
    };
    static CalculateIgnition(config) {
        ;
        let density = config.density ? parseFloat(config.density) : 0;
        let viscosity = config.viscosity ? parseFloat(config.viscosity) : 0;
        let temperature = config.temperature ? parseFloat(config.temperature) : 0;
        ///let Log10 = Math.log(10);
        //let CDbl = 134.345;

        let loglogX = Math.log10(Math.log10(parseFloat(viscosity) + 0.85));
        let logT = Math.log10  ((parseFloat(temperature) + 273.0) / 323.0);
        let CCAI = (parseFloat(density) - 81.0 - (141.0 * loglogX) - (483.0 * logT)).toFixed(1);
        let x = parseFloat (viscosity) + 0.7;
        let logX = Math.log10  (x);
        let formula = Math.log10(logX);
        let CII = ((270.795 + 0.1038 * parseFloat(temperature)) - (0.254565 * parseFloat(density)) + (23.708 * formula)).toFixed(1);

        return (({ CCAIresult: CCAI ? CCAI : "", CIIresult: CII ? CII : "" }))

        // let CDbl="134.345";
        // let x = cDbl*(viscosity)+0.7;
        // let logX = log10(x);


    }
}